module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_inbound-08266c0f33e2319e8c3cee6fcd500a7c.svg";